import brand from '@helpers/brand';
import styled from 'styled-components';
import { rgba } from 'polished';
import fonts from '@helpers/fonts';
const Container = styled.div `
  position: relative;
`;
const Image = styled.img `
  display: block;
  width: 100%;

  [data-image-mode='contain'] & {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: contain;
    height: 100%;
    object-position: center center;
  }

  [data-image-mode='cover'] & {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    height: 100%;
    object-position: center center;
  }
`;
const ImageCredit = styled.span `
  ${fonts.sourceSansPro.regular};
  position: absolute;
  z-index: 2;
  bottom: 0;
  right: 0;
  color: ${brand.white};
  background-color: ${rgba(brand.black, 0.8)};
  padding: 5px 20px;
  border-radius: 12px 12px 0 0;
  font-size: 16px;
  line-height: 28px;
`;
export default {
    Container,
    Image,
    ImageCredit,
};
